import Vue from 'vue';
import VuePageTitle from 'vue-page-title';
import VueRouter from 'vue-router';

export default (router: VueRouter, brand: string) => {
  Vue.use(VuePageTitle, { router, suffix: ` - ${brand}` });
};
